import { Navigate, Route, Routes } from "react-router-dom";
import { Question1Page } from "../pages/Question1Page";
import { Question2Page } from "../pages/Question2Page";
import { Question3Page } from "../pages/Question3Page";
import { Question4Page } from "../pages/Question4Page";
import { DealerSelectionPage } from "../pages/DealerSelectionPage";
import { PersonalInformationPage } from "../pages/PersonalInformationPage";
import { SummaryPage } from "../pages/SummaryPage";
import { ConfirmationPage } from "../pages/ConfirmationPage";

export const MatchMakerRoutes = () => {
    return (
        <Routes>
            <Route path="/match-maker/question-page1" element={<Question1Page />} />
            <Route path="/match-maker/question-page2" element={<Question2Page />} />
            <Route path="/match-maker/question-page3" element={<Question3Page />} />
            <Route path="/match-maker/question-page4" element={<Question4Page />} />
            <Route path="/dealer-selection" element={<DealerSelectionPage />} />
            <Route path="/personal-information" element={<PersonalInformationPage />} />
            <Route path="/summary" element={<SummaryPage />} />
            <Route path="/confirmation" element={<ConfirmationPage />} />
            <Route path="*" element={<Navigate to={"/error-page"} replace />} />
        </Routes>
    );
};
